import clsx from 'clsx'
import { type MouseEventHandler, useEffect, useState } from 'react'

import { FvLinkButton, Icon, type IconProps } from '@fv/client-components'
import type { AuditStatus } from '@fv/models'

import { useAuditListCount } from './queries'

const animationLength = 450

type AuditListTabProps = {
  icon: IconProps['icon']
  iconClassName?: string
  isActive: boolean
  label: string
  onClick: MouseEventHandler<HTMLAnchorElement>
  status: AuditStatus
}

const AuditListTab = ({
  icon,
  iconClassName,
  isActive,
  label,
  onClick,
  status,
}: AuditListTabProps) => {
  const { count, hasFilters, isLoading } = useAuditListCount(status)
  const [prevCount, setPrevCount] = useState(count)

  useEffect(() => {
    let isMounted = true

    setTimeout(() => {
      isMounted && setPrevCount(count)
    }, animationLength)

    return () => {
      isMounted = false
    }
  }, [count])

  return (
    <FvLinkButton
      className={clsx({
        'underline decoration-2 decoration-fv-orange-bright underline-offset-8':
          isActive,
      })}
      icon={icon}
      iconClass={iconClassName}
      id={status}
      onClick={onClick}
    >
      <span>{label}</span>
      {(status !== 'archived' || hasFilters) && (
        <span
          className={clsx(
            'inline-block border border-fv-gray bg-white py-[.2rem] px-[.3rem] min-w-7 rounded-xs text-center ml-2',
            {
              'scale-up-down-animation': count > prevCount,
            },
          )}
        >
          {isLoading ? <Icon icon="spinner" /> : count}
        </span>
      )}
    </FvLinkButton>
  )
}

export default AuditListTab
